<template>
  <form @submit.prevent class="trial-form">

    <h3>Study Details</h3>

    <div class="trial-details">
      <rp-textinput
        v-model="resource.name"
        placeholder="Study Name"
        :isRequired="true"
        :disabled="disabled"
        :error="nameError"
        @input="touch('name')" />
      <rp-textinput
        v-model="resource.enrolment_target"
        placeholder="Recruitment Target"
        :isRequired="true"
        :disabled="disabled"
        :error="enrolment_targetError"
        @input="touch('enrolment_target')" />
      <rp-datepicker
        v-model="resource.end_date"
        placeholder="Target End Date"
        :yearToOffset=5
        :yearFromOffset=-1
        :isRequired="true"
        :disabled="disabled"
        :error="end_dateError"
        @input="touch('end_date')" />
      <rp-multicheck
        v-model="resource.questionnaire_ids"
        :options="questionnaireOptions"
        :text="'Questionnaires'"
        :disabled="disabled" />
    </div>

    <h3>Enrol Surgeons</h3>

    <div class="trial-surgeons">
      <rp-surgeonenrol
        :surgeonsPage="surgeonsPage"
        :selectedEnrolments="selectedEnrolments"
        @getUsers="getUsers" />
    </div>

    <rp-button :disabled="isInvalid" type="primary" @click="submit">Submit</rp-button>
  </form>
</template>

<script>
  import form from '../../../mixins/form'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import Button from '../../../components/ui/inputs/Button'
  import CheckBox from '../../../components/ui/inputs/Checkbox'
  import MultiCheck from '../../../components/ui/inputs/MultiCheck'
  import DatePicker from '../../../components/ui/inputs/DatePicker'
  import TrialSurgeonEnrolTable from '../TrialSurgeonEnrolTable'
  import {errorMessages} from '../../../api/error_messages'
  import {validationMixin} from 'vuelidate'
  import {date} from '../../../api/validators'
  import {required, numeric} from 'vuelidate/lib/validators'

  export default {
    mixins: [form, validationMixin],

    components: {
      'rp-textinput': TextInput,
      'rp-button': Button,
      'rp-checkbox': CheckBox,
      'rp-multicheck': MultiCheck,
      'rp-datepicker': DatePicker,
      'rp-surgeonenrol': TrialSurgeonEnrolTable,
    },

    data() {
      return {
        selectedEnrolments: [],
      }
    },

    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      surgeonsPage: Object,
      questionnaires: Array,
    },

    computed: {
      ...errorMessages([
        'name',
        'enrolment_target',
        'end_date'
      ]),

      questionnaireOptions() {
        let options = []
        this.questionnaires.forEach((q) => {
          options.push({text: q.name, value: q.id})
        })
        return options
      },

      payload() {
        return {
          name: this.resource.name,
          enrolment_target: this.resource.enrolment_target,
          end_date: this.resource.end_date + "T23:59:59Z",
          questionnaire_ids: this.resource.questionnaire_ids,
          surgeon_enrolments: this.selectedEnrolments.filter((x) => x.selected)
        }
      },
    },

    methods: {
      getUsers(page) {
        this.$emit('getUsers', page)
      },

      submit() {
        this.$emit('submit', this.payload)
      },

      populateQuestionnaires() {
        this.resource.questionnaire_ids = []
        this.questionnaires.forEach((q) => {
          this.resource.questionnaire_ids.push(q.id)
        })
      },
    },

    watch: {
      questionnaires: {
        handler: function(_val) {
          this.populateQuestionnaires()
        }
      },
    },

    validations: {
      resource: {
        name: {required},
        enrolment_target: {required, numeric},
        end_date: {required, date},
        questionnaire_ids: {required},
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'
  @import '../../../styles/base/themes'

  .trial-form
    max-width: 1200px  
    padding: 20px
    border-radius: 20px    
    background: $color-panel-bg

    h3
      margin-top: 0
      margin-bottom: 0
      text-transform: none

    .trial-details
      display: flex
      gap: 20px
      > div
        flex: 1 1 0px

  table
    padding: 10px
    width: 100%
    border-collapse: collapse

    td
      &.tdbutton
        width: 20px

      .status
        display: block

      div
        span
          display: flex
          justify-content: center

  thead
    @include themify($themes)
      background: themed('thead-background')
      color: themed('thead-color')

    font-weight: bold
    text-transform: uppercase
  
    td
      white-space: nowrap
      line-height: 1

      &.tdbutton
        text-align: center

      @include themify($themes)
        padding: themed('thead-td-padding')
        font-weight: themed('thead-td-weight')
        font-size: themed('thead-font-size')
        
      &:first-child 
        @include themify($themes)
          border-radius: themed('td-radius-left')

      &:last-child
        @include themify($themes)
          border-radius: themed('td-radius-right')

  tr
    @include themify($themes)
      border-bottom: themed('tr-border-bottom')
  
    &:first-child
      @include themify($themes)
        border-top: themed('tr-border-top')
    td
      @include themify($themes)
        padding: themed('td-padding')
      
      font-size: 12px
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/Trial.vue